import React from 'react';

const CardPos = (props: object) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.94531 11.9093L11.9078 2.94678"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32812 13.7096L9.22812 12.8096"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3438 11.6914L12.1363 9.89893"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.70095 7.67913L7.68095 2.69913C9.27095 1.10913 10.066 1.10163 11.641 2.67663L15.3235 6.35913C16.8985 7.93413 16.891 8.72913 15.301 10.3191L10.321 15.2991C8.73095 16.8891 7.93595 16.8966 6.36095 15.3216L2.67845 11.6391C1.10345 10.0641 1.10345 9.27663 2.70095 7.67913Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 16.499H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CardPos;
